(() => {
  const shuffle = items => {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };

  const plainText = html => new DOMParser().parseFromString(html || '', 'text/html').body.textContent.trim().replace(/\s+/g, ' ');

  const speciesName = product => {
    const text = `${product.title || ''} ${plainText(product.body_html)}`.toLowerCase();
    if (text.includes('honduran')) return 'Honduran Milksnake';
    if (text.includes('pueblan')) return 'Pueblan Milksnake';
    if (text.includes('variable')) return 'Variable Kingsnake';
    if (text.includes('mexmex') || text.includes('san luis')) return 'San Luis Potosí Kingsnake';
    if (text.includes('knobloch')) return 'Knobloch’s Mountain Kingsnake';
    if (text.includes('arizona') || text.includes('pyro')) return 'Arizona Mountain Kingsnake';
    return product.title || 'Other';
  };

  const productPrice = product => Math.min(...product.variants.map(variant => Number(variant.price)));
  const productDate = product => Date.parse(product.created_at || product.published_at || 0) || 0;

  async function loadProducts(grid) {
    if (grid.dataset.inventorySnapshot) {
      const response = await fetch(grid.dataset.inventorySnapshot);
      if (!response.ok) throw new Error('Inventory unavailable');
      return (await response.json()).products;
    }
    const products = [];
    for (let page = 1; ; page++) {
      const url = new URL(`${grid.dataset.inventoryCollection}/products.json`, location.origin);
      url.searchParams.set('limit', '250');
      url.searchParams.set('page', String(page));
      const response = await fetch(url);
      if (!response.ok) throw new Error('Inventory unavailable');
      const data = await response.json();
      if (!Array.isArray(data.products)) throw new Error('Invalid inventory');
      products.push(...data.products);
      if (data.products.length < 250) return products;
    }
  }

  function card(product, grid) {
    const available = product.variants.some(variant => variant.available);
    const species = speciesName(product);
    const article = document.createElement('article');
    article.className = 'product-card';
    article.dataset.type = /milk/i.test(species) ? 'milk' : 'king';
    article.dataset.species = species;
    article.dataset.price = String(productPrice(product));
    article.dataset.createdAt = String(productDate(product));
    const link = document.createElement('a');
    const base = grid.dataset.productBase || '';
    link.href = `${base}/products/${encodeURIComponent(product.handle)}`;
    const media = document.createElement('div');
    media.className = 'product-image';
    if (product.images[0]) {
      const image = document.createElement('img');
      image.src = product.images[0].src;
      image.alt = product.images[0].alt || product.title;
      image.loading = 'lazy';
      image.width = product.images[0].width || 900;
      image.height = product.images[0].height || 900;
      media.append(image);
    }
    if (available) {
      const badge = document.createElement('span');
      badge.textContent = 'Available';
      media.append(badge);
    }
    const meta = document.createElement('div');
    meta.className = 'product-meta';
    const speciesLabel = document.createElement('p');
    speciesLabel.textContent = species;
    const title = document.createElement('h3');
    title.textContent = product.title;
    const detail = document.createElement('p');
    detail.className = 'trait';
    const description = plainText(product.body_html);
    detail.textContent = description.length > 72 ? `${description.slice(0, 69)}…` : description;
    const price = document.createElement('strong');
    price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency', currency: grid.dataset.currency || 'CAD', currencyDisplay: 'code'
    }).format(productPrice(product));
    meta.append(speciesLabel, title, detail, price);
    link.append(media, meta);
    article.append(link);
    return article;
  }

  const compareProducts = sort => (a, b) => {
    if (sort === 'oldest') return productDate(a) - productDate(b);
    if (sort === 'price-asc') return productPrice(a) - productPrice(b);
    if (sort === 'price-desc') return productPrice(b) - productPrice(a);
    if (sort === 'species-asc') return speciesName(a).localeCompare(speciesName(b)) || a.title.localeCompare(b.title);
    if (sort === 'species-desc') return speciesName(b).localeCompare(speciesName(a)) || a.title.localeCompare(b.title);
    return productDate(b) - productDate(a);
  };

  function render(grid, products) {
    const fragment = document.createDocumentFragment();
    products.forEach(product => fragment.append(card(product, grid)));
    if (!products.length) {
      const empty = document.createElement('p');
      empty.textContent = 'No available snakes match this selection.';
      fragment.append(empty);
    }
    grid.replaceChildren(fragment);
  }

  function organize(grid) {
    const controls = document.querySelector(`[data-product-controls="${grid.id}"]`);
    if (!controls || !grid._inventoryProducts) return;
    const speciesSelect = controls.querySelector('[data-species-filter]');
    const sortSelect = controls.querySelector('[data-sort-products]');
    const selectedSpecies = speciesSelect.value;
    const products = grid._inventoryProducts
      .filter(product => selectedSpecies === 'all' || speciesName(product) === selectedSpecies)
      .sort(compareProducts(sortSelect.value));
    render(grid, products);
    const count = controls.querySelector('[data-results-count]');
    if (count) count.textContent = `${products.length} ${products.length === 1 ? 'snake' : 'snakes'}`;
  }

  function setupOrganization(grid, products) {
    const controls = document.querySelector(`[data-product-controls="${grid.id}"]`);
    if (!controls) return;
    grid._inventoryProducts = products;
    const speciesSelect = controls.querySelector('[data-species-filter]');
    const sortSelect = controls.querySelector('[data-sort-products]');
    const previousSpecies = speciesSelect.value;
    const species = [...new Set(products.map(speciesName))].sort((a, b) => a.localeCompare(b));
    speciesSelect.replaceChildren(new Option('All species', 'all'), ...species.map(name => new Option(name, name)));
    speciesSelect.value = species.includes(previousSpecies) ? previousSpecies : 'all';
    speciesSelect.onchange = () => organize(grid);
    sortSelect.onchange = () => organize(grid);
    organize(grid);
  }

  async function refresh(grid) {
    try {
      let products = await loadProducts(grid);
      if (grid.dataset.availableOnly === 'true') products = products.filter(product => product.variants.some(variant => variant.available));
      if (grid.dataset.organizable === 'true') {
        setupOrganization(grid, products);
        return;
      }
      if (grid.dataset.randomize === 'true') shuffle(products);
      const limit = Number(grid.dataset.inventoryLimit);
      if (limit) products = products.slice(0, limit);
      render(grid, products);
    } catch (error) {
      if (grid.dataset.randomize === 'true') {
        const cards = shuffle([...grid.querySelectorAll('.product-card')]);
        const pagination = grid.querySelector('.pagination');
        cards.forEach(item => grid.insertBefore(item, pagination));
      }
    }
  }

  const refreshAll = () => document.querySelectorAll('[data-random-inventory]').forEach(refresh);
  refreshAll();
  window.addEventListener('pageshow', event => { if (event.persisted) refreshAll(); });
  document.addEventListener('shopify:section:load', refreshAll);
})();
